<template>
  <v-container fluid>
    <v-row style="user-select:none">
      <v-col cols="12" md="6" align-self="center">
        <v-card class="mx-auto" flat color="#00000000">
          <v-list-item two-line>
            <v-list-item-avatar tile size="80">
              <v-icon color="primary" size="50px">far fa-user</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1" style="font-weight:500"
                >Minha<br />Conta</v-list-item-title
              >
              <v-list-item-subtitle
                >Altere todos os aspectos <br v-if="isMobile" />
                de sua conta
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" align-self="center">
        <v-card class="py-0" v-if="!isMobile">
          <v-card-text class="py-2  pb-0 mb-0">
            <v-row class="planOverview">
              <v-col cols="6" class="greenRightBorder pr-5 mb-3">
                <span class="item-title">Minha Assinatura</span><br />
                <span class="item-loading" v-if="planOverviewLoading"
                  ><v-icon small color="secondary"
                    >fas fa-spinner fa-spin</v-icon
                  ></span
                >
                <span class="name greenText" v-else
                  >{{ planOverview.name }}
                  <br />
                </span>

                <div style="margin-top:5px" v-if="planOverview.renew != '-'">
                  <span class="item-title">Renovação do plano</span><br />
                  <span class="item-loading" v-if="planOverviewLoading"
                    ><v-icon small color="secondary"
                      >fas fa-spinner fa-spin</v-icon
                    ></span
                  >
                  <span class="greenText" v-else>{{ planOverview.renew }}</span>

                  <span class="item-date" v-if="!planOverviewLoading"
                    >&nbsp;({{ planOverview.renewDay }})</span
                  >
                </div>
              </v-col>
              <v-col cols="6" class="pl-5 pb-0 mb-0">
                <span class="item-title"
                  >Uso de Redirecionamentos:&nbsp;<br
                /></span>
                <span class="item-loading" v-if="planOverviewLoading"
                  ><v-icon small color="secondary"
                    >fas fa-spinner fa-spin</v-icon
                  ></span
                >
                <span class="usage" v-else>
                  {{ planOverview.utilization.current }} /
                  <span v-if="planOverview.utilization.max < 10000000">{{
                    planOverview.utilization.max
                  }}</span>
                  <v-icon v-else small color="secondary"
                    >fas fa-infinity</v-icon
                  >
                </span>
                <v-progress-linear
                  :value="calcUsagePercent"
                  color="primary"
                  :indeterminate="planOverviewLoading"
                  rounded
                  height="10"
                ></v-progress-linear>
                <div style="margin-top:5px">
                  <span class="item-title">Previsão de esgotamento</span><br />
                  <span class="item-loading" v-if="planOverviewLoading"
                    ><v-icon small color="secondary"
                      >fas fa-spinner fa-spin</v-icon
                    >.</span
                  >
                  <span class="greenText" v-else>{{
                    planOverview.depletion
                  }}</span>
                </div>
                <br />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <!-- Mobile -->
        <v-card class="py-0" v-else>
          <v-card-text class="py-2">
            <v-row class="planOverview">
              <v-col cols="6" class="greenRightBorder pr-5 py-0 my-0">
                <span class="item-title">Minha Assinatura</span><br />
                <span class="item-loading" v-if="planOverviewLoading"
                  ><v-icon small color="secondary"
                    >fas fa-spinner fa-spin</v-icon
                  ></span
                >
                <span class="name greenText" v-else
                  >{{ planOverview.name }}
                  <br />
                </span>
              </v-col>
              <v-col cols="6" class="pl-5 py-0 my-0">
                <span class="item-title">Uso atual:&nbsp;<br /></span>
                <span class="item-loading" v-if="planOverviewLoading"
                  ><v-icon small color="secondary"
                    >fas fa-spinner fa-spin</v-icon
                  ></span
                >
                <span class="usage" v-else>
                  {{ planOverview.utilization.current }} /
                  <span v-if="planOverview.utilization.max < 10000000">{{
                    planOverview.utilization.max
                  }}</span>
                  <v-icon v-else small color="secondary"
                    >fas fa-infinity</v-icon
                  >
                </span>
                <v-progress-linear
                  :value="calcUsagePercent"
                  color="primary"
                  :indeterminate="planOverviewLoading"
                  rounded
                  height="15"
                ></v-progress-linear>
              </v-col>
              <v-col cols="12" class="mt-1 pb-0 mb-0">
                <span class="item-title">Renovação do plano: </span>
                <span class="item-loading" v-if="planOverviewLoading"
                  ><v-icon small color="secondary"
                    >fas fa-spinner fa-spin</v-icon
                  ></span
                >
                <span class="greenText" v-else>{{ planOverview.renew }} </span>

                <span
                  class="item-date"
                  style="font-size:11px"
                  v-if="!planOverviewLoading"
                  >({{ planOverview.renewDay }})</span
                >
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-container fluid>
            <v-row v-if="isMobile">
              <v-col cols="12" class="pa-0 ma-0">
                <v-tabs
                  height="50px"
                  centered
                  center-active
                  icons-and-text
                  color="secondary"
                >
                  <v-tab
                    v-for="(item, i) in menuItensFilter"
                    :key="i"
                    :to="item.link"
                  >
                    <span class="tabText">{{ item.mobile }}</span>
                    <v-icon small v-text="item.icon"></v-icon>
                  </v-tab>
                </v-tabs>
              </v-col>
              <v-col cols="12">
                <router-view></router-view>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="3" xl="2">
                <v-navigation-drawer permanent width="100%">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="title text-center userName">
                        {{ userName }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="text-center userEmail">
                        {{ userEmail }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list dense nav flat>
                    <v-list-item-group mandatory color="secondary">
                      <v-list-item
                        v-for="(item, i) in menuItensFilter"
                        :key="i"
                        :to="item.link"
                      >
                        <v-list-item-icon>
                          <v-icon
                            small
                            color="secondary"
                            v-text="item.icon"
                          ></v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                          <v-list-item-title
                            class="subMenuText"
                            v-text="item.title"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-navigation-drawer>
              </v-col>
              <v-col cols="9" xl="10">
                <router-view></router-view>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";

export default {
  name: "Configs",
  components: {},
  data: () => ({
    itemsMenu: [
      {
        id: 1,
        link: "/profile/user",
        title: "Meu Perfil",
        mobile: "Perfil",
        icon: "far fa-user"
      },
      {
        id: 2,
        link: "/profile/pass",
        title: "Trocar Senha",
        mobile: "Senha",
        icon: "fas fa-unlock-alt"
      },
      {
        id: 3,
        link: "/profile/client",
        title: "Minha Empresa",
        mobile: "Cliente",
        icon: "fas fa-business-time"
      },
      {
        id: -4,
        link: "/profile/users",
        title: "Usuários",
        mobile: "Usuários",
        icon: "fas fa-users"
      },
      {
        id: 5,
        link: "/profile/plans",
        title: "Planos",
        mobile: "Planos",
        icon: "fas fa-clipboard-list"
      },
      {
        id: -6,
        link: "/profile/cards",
        title: "Meus Cartões",
        mobile: "Cartões",
        icon: "far fa-credit-card"
      },
      {
        id: -7,
        link: "/profile/invoices",
        title: "Faturas",
        mobile: "Faturas",
        icon: "fas fa-file-invoice-dollar"
      }
    ],
    planOverviewLoading: false
  }),
  computed: {
    menuItensFilter: function() {
      return this.itemsMenu.filter((menu) => {
        return menu.id > 0;
      });
    },
    calcUsagePercent: function() {
      if (this.planOverviewLoading) return 0;
      const used = this.planOverview.utilization.current;
      const max = this.planOverview.utilization.max;
      return max > 0 ? (used / max) * (100).toFixed(0) : 0;
    },
    ...mapState({
      userName: (state) => state.appStore.userName,
      userEmail: (state) => state.appStore.userEmail,
      planOverview: (state) => state.planStore.planOverview,
      isMobile: (state) => state.appStore.isMobile,
      isPortrait: (state) => state.appStore.isPortrait
    })
  },
  methods: {},
  mounted() {
    this.planOverviewLoading = true;
    this.$store.dispatch("planStore/getPlanOverview").then(() => {
      this.planOverviewLoading = false;
    });
  }
};
</script>
<style>
.planOverview .greenRightBorder {
  border-right: 1px #60ba8e88 solid;
}
.planOverview .name {
  text-transform: uppercase;
}
.planOverview .greenText {
  color: #60ba8e;
  font-size: 16px;
}
.planOverview .usage {
  display: block;
  width: 100%;
  text-align: center;
}
.planOverview .item-loading {
  width: 100%;
  display: block;
  text-align: center;
  margin-bottom: 5px;
}
.planOverview .item-title {
  color: #132237;
  font-size: 13px;
}
.planOverview .item-date {
  color: #13223795;
  font-size: 12px;
}
.userName {
  text-transform: uppercase;
  user-select: none;
}
.userEmail {
  user-select: none;
}
.v-slide-group__prev {
  display: none !important;
}
.subMenuText {
  font-size: 16px !important;
  font-weight: 400 !important;
}
.tabText {
  padding-top: 3px;
  margin: 10px auto 5px !important;
  font-size: xx-small;
}
</style>
